import { ActionType } from '../../constants/ActionTypes'

export default function bonusesReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_BONUSES_BEGIN:
            return {
                ...state,
                isLoading: true,
                result: []
            }
        case ActionType.GET_BONUS_GAMES_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ActionType.GET_BONUSES_ERROR:
            return {
                ...state,
                isLoading: false,
                result: []
            }
        case ActionType.GET_BONUSES_SUCCESS:

            const bonuses = {};
            action.payload.clientBonuses = action.payload.clientBonuses ? action.payload.clientBonuses : action.payload.entities // need to be changed
            action.payload.clientBonuses && action.payload.clientBonuses.map((bonus, index) => {
                bonuses[index] = bonus;
            });

            return {
                ...state,
                isLoading: false,
                result: {
                    ...action.payload,
                    bonuses: bonuses
                }
            }
        case ActionType.GET_BONUS_GAMES_ERROR:
            return {
                ...state,
                isLoading: false,
            }
        // Prizes 
        case ActionType.GET_PRIZES_ERROR:
            return {
                ...state,
                isLoading: false,
                prizesData: []
            }
        case ActionType.GET_PRIZES_BEGIN:
            return {
                ...state,
                isLoading: true,
                prizesData: {
                    ...action.payload
                }
            }
        case ActionType.GET_PRIZES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                prizesData: action.payload
            }
        // Activate promo code
        case ActionType.ACTIVATE_PROMO_CODE_BEGIN:
            return {
                ...state,
                isPromoLoading: true,
            }
        case ActionType.ACTIVATE_PROMO_CODE_ERROR:
            return {
                ...state,
                isPromoLoading: false,
            }
        case ActionType.ACTIVATE_PROMO_CODE_SUCCESS:
            return {
                ...state,
                promoCodeData: action.payload,
                isPromoLoading: false,
                showSuccessModal: true
            }

        case ActionType.CLOSE_PROMO_CODE_SUCCESS_MODAL:
            return {
                ...state,
                showSuccessModal: false,
                promoCodeData: null
            }

        case ActionType.GET_BONUS_CAMPAIGNS_LOAD_MORE_BEGIN:
            return {
                ...state,
                isMoreBonusloading: true,
                offersObj: {
                    ...state.offersObj,
                    hasNext: false
                }
            }
        case ActionType.GET_BONUS_CAMPAIGNS_BEGIN:
            return {
                ...state,
                isBonusloading: true,
                offersObj: {
                    ...state.offersObj,
                    offers: [],
                    hasNext: false
                }
            }
        case ActionType.GET_BONUS_CAMPAIGNS_ERROR:
            return {
                ...state,
                isBonusloading: false,
                isMoreBonusloading: false

            }
        case ActionType.GET_BONUS_CAMPAIGNS_SUCCESS:
            return {
                ...state,
                isBonusloading: false,
                isMoreBonusloading: false,
                offersObj: {
                    offers: [...state.offersObj.offers, ...action.payload.entries],
                    hasNext: action.payload.hasNext
                }
            }
        case ActionType.GET_BONUS_DETAILS_BEGIN:
            return {
                ...state,
                offerDetails: null,
                isGamesLoading: true,
                offerProducts: {
                    products: [],
                    hasNext: false
                }
            }
        case ActionType.GET_BONUS_DETAILS_ERROR:
            return {
                ...state,
                isGamesLoading: false
            }
        case ActionType.GET_BONUS_DETAILS_SUCCESS:
            return {
                ...state,
                isGamesLoading: false,
                offerDetails: action.payload
            }
        case ActionType.GET_BONUS_PRODUCTS_LOAD_MORE_BEGIN:
            return {
                ...state,
                isMoreProductsloading: true,
                offerProducts: {
                    ...state.offerProducts,
                    hasNext: false
                }
            }
        case ActionType.GET_BONUS_PRODUCTS_BEGIN:
            return {
                ...state,
                isProductsLoading: true,
                offerProducts: {
                    ...state.offerProducts,
                    hasNext: false
                }
            }
        case ActionType.GET_BONUS_PRODUCTS_ERROR:
            return {
                ...state,
                isProductsLoading: false,
                isMoreProductsloading: false,

            }
        case ActionType.GET_BONUS_PRODUCTS_SUCCESS:
            return {
                ...state,
                isMoreProductsloading: false,
                isProductsLoading: false,
                offerProducts: {
                    products: action.payload.isSearch ? action.payload.data.entries : [...state.offerProducts.products, ...action.payload.data.entries],
                    hasNext: action.payload.data.hasNext
                }
            }
        case ActionType.ACTIVATE_BONUS_CAMPAIGN_BEGIN:
        case ActionType.RESUME_BONUS_CAMPAIGN_BEGIN:
        case ActionType.CANCEL_BONUS_CAMPAIGN_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.ACTIVATE_BONUS_CAMPAIGN_ERROR:
        case ActionType.ACTIVATE_BONUS_CAMPAIGN_SUCCESS:
        case ActionType.CANCEL_BONUS_CAMPAIGN_ERROR:
        case ActionType.CANCEL_BONUS_CAMPAIGN_SUCCESS:
        case ActionType.RESUME_BONUS_CAMPAIGN_ERROR:
        case ActionType.RESUME_BONUS_CAMPAIGN_SUCCESS:
            return {
                ...state,
                inProcess: false
            }
        case ActionType.GET_BONUS_GAMES_SUCCESS:
            const bonusId = Number(action.payload.bonusId);
            return {
                ...state,
                isLoading: false,
                result: {
                    ...state.result,
                    clientBonuses: {
                        ...state.result.bonuses,
                        [bonusId]: {
                            ...state.result.bonuses[bonusId],
                            games: action.payload.games
                        }
                    }

                }
            }
        case ActionType.GET_BONUS_WALLET_BEGIN:
            return {
                ...state,
                isBonusWalletLoading: true,
            }
        case ActionType.GET_BONUS_WALLET_ERROR:
            return {
                ...state,
                isBonusWalletLoading: false,
            }
        case ActionType.GET_BONUS_WALLET_SUCCESS:
            return {
                ...state,
                isBonusWalletLoading: false,
                balanceType: action.payload?.data?.IsBonusWalletActive
            }
        case ActionType.CHECK_BALANCE_SWITCHER:
            return {
                ...state,
                activeBalanceSwitcher: action.payload
            }
        case ActionType.CHANGE_BONUS_WALLET_BEGIN:
            return {
                ...state,
                isBonusWaletLoading: true,
            }
        case ActionType.CHANGE_BONUS_WALLET_ERROR:
            return {
                ...state,
                isBonusWaletLoading: false,
            }
        case ActionType.CHANGE_BONUS_WALLET_SUCCESS:
            return {
                ...state,
                isBonusWaletLoading: false,
                balanceType: payload
            }
        case ActionType.GET_SPORT_TYPES_BEGIN:
            return {
                ...state,
                sportTypes: null,
                bonusTournaments: null,
                bonusEvents: null,
                isSportTypesLoading: true
            }
        case ActionType.GET_SPORT_TYPES_ERROR:
            return {
                ...state,
                isSportTypesLoading: false
            }
        case ActionType.GET_SPORT_TYPES_SUCCESS:
            return {
                ...state,
                sportTypes: action.payload.data,
                isSportTypesLoading: false
            }

        case ActionType.GET_BONUS_TOURNAMENTS_BEGIN:
            return {
                ...state,
                isBonusTournamentsLoading: true
            }
        case ActionType.GET_BONUS_TOURNAMENTS_ERROR:
            return {
                ...state,
                isBonusTournamentsLoading: false
            }
        case ActionType.GET_BONUS_TOURNAMENTS_SUCCESS:
            return {
                ...state,
                bonusTournaments: action.payload.data,
                isBonusTournamentsLoading: false
            }

        case ActionType.GET_BONUS_EVENTS_BEGIN:
            return {
                ...state,
                isBonusEventsLoading: true
            }
        case ActionType.GET_BONUS_EVENTS_ERROR:
            return {
                ...state,
                isBonusEventsLoading: false
            }
        case ActionType.GET_BONUS_EVENTS_SUCCESS:
            return {
                ...state,
                bonusEvents: action.payload.data,
                isBonusEventsLoading: false
            }
        case ActionType.GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_BEGIN:
            return {
                ...state,
            }
        case ActionType.GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_ERROR:
            return {
                ...state,
            }
        case ActionType.GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_SUCCESS:
            return {
                ...state,
                bonusesCounts: action.payload,
            }
        case ActionType.SET_CLIENT_NEW_BONUS_SETTINGS_COUNT_SUCCESS:
            return {
                ...state,
                bonusesCounts: {
                    ...state.bonusesCounts,
                    newBonusesCount: action.payload
                }
            }
        case ActionType.GET_BONUS_MARKETS_SUCCESS:
            return {
                ...state,
                bonusMarkets: action.payload,
                isBonusMarketsLoading: false
            }
        default:
            return state;
    }
}

